import React from "react";
import "../document.css";
// описание тех средств хранения кода ГОТОВО
const Technical = () => {
  return (
    <div className="technical-page">
      <div className="container">
        <h1 className="page-title">
          ОПИСАНИЕ ТЕХНИЧЕСКИХ СРЕДСТВ ХРАНЕНИЯ ИСХОДНОГО ТЕКСТА И ОБЪЕКТНОГО
          КОДА ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ, А ТАКЖЕ ТЕХНИЧЕСКИХ СРЕДСТВ КОМПИЛЯЦИИ
          ИСХОДНОГО ТЕКСТА В ОБЪЕКТНЫЙ КОД ПРОГРАММНОГО ОБЕСПЕЧЕНИЯ «ИММЕТРИКС»
        </h1>

        <section className="technical-section">
          <h2 className="section-title">
            I. Описание технических средств хранения исходного текста и
            объектного кода программного обеспечения, а также технических
            средств компиляции исходного текста в объектный код программного
            обеспечения «Имметрикс»:
          </h2>

          <p className="section-text">
            Хранение кода осуществляется в репозиториях:
          </p>

          <ul className="repository-list">
            <li>
              <a href="https://gitflame.ru/zalaev-emin/theatre-frontend" className="repo-link">
                https://gitflame.ru/zalaev-emin/theatre-frontend
              </a>
            </li>
            <li>
              <a
                href="https://gitflame.ru/zalaev-emin/theatre-android"
                className="repo-link"
              >
                https://gitflame.ru/zalaev-emin/theatre-android
              </a>
            </li>
            <li>
              <a
                href="https://gitflame.ru/zalaev-emin/theatre-frontend"
                className="repo-link"
              >
                https://gitflame.ru/zalaev-emin/theatre-frontend
              </a>
            </li>
          </ul>

          <p className="section-text">
            В качестве конечного продукта код хранится на внутренних серверах в
            docker контейнерах или на серверах хостинга и поставка кода
            осуществляется путем выстроенного CI CD процесса в GitLab.
            Инструментарий - GitLab Auto DevOps
          </p>

          <div className="technology-description">
            <p className="section-text go">
              <strong>Go (Golang)</strong> — это статически типизированный,
              компилируемый язык программирования, разработанный в Google. Его
              отличают простота синтаксиса, высокая производительность,
              встроенная поддержка конкурентности через горутины и каналы, а
              также статическая система типов, которая помогает отлавливать
              ошибки ещё на этапе компиляции.
            </p>

            <p className="section-text go">
              Go требует предварительной компиляции исходного кода в бинарный
              исполняемый файл. Этот файл уже не зависит от внешнего
              интерпретатора или виртуальной машины и может быть запущен
              напрямую на целевой системе.
            </p>

            <h3 className="subsection-title go">
              Порядок работы обычно такой:
            </h3>

            <ul className="workflow-list goy">
              <li>
                <span className="list-item-text ">
                  Исходный код пишется в .go файлах.
                </span>
              </li>
              <li>
                <span className="list-item-text">
                  Для запуска локально используется команда{" "}
                  <code>go run main.go</code> — при этом Go сначала компилирует
                  код во временный бинарник и сразу его запускает.
                </span>
              </li>
              <li>
                <span className="list-item-text">
                  Для получения полноценного приложения используется команда{" "}
                  <code>go build</code>, которая компилирует проект в отдельный
                  исполняемый файл (например, <code>app</code>
                  или <code>app.exe</code> на Windows). Этот бинарник можно
                  перенести на любой сервер с той же архитектурой и операционной
                  системой и запускать без дополнительных зависимостей.
                </span>
              </li>
              <li>
                <span className="list-item-text">
                  Go имеет встроенный менеджер пакетов и систему модулей (
                  <code>go mod init</code>,<code> go mod tidy</code>), поэтому
                  подключение внешних библиотек ("пакетов") делается напрямую
                  через <code>import</code> и автоматическую загрузку.
                </span>
              </li>
              <li>
                <span className="list-item-text">
                  Изменения в исходном коде требуют пересборки — в отличие от
                  Ruby on Rails, где изменения подхватываются "на лету". Однако
                  сборка в Go очень быстрая, поэтому цикл "изменил → собрал →
                  запустил" почти не ощутим.
                </span>
              </li>
            </ul>

            <p className="section-text go">
              Таким образом, в Go акцент делается на компиляцию в быстрые и
              автономные бинарные приложения, которые можно легко разворачивать
              и запускать в продакшене без дополнительных инструментов, что
              делает язык удобным для микросервисов и высоконагруженных систем.
            </p>
          </div>
        </section>

        <section className="technical-section">
          <h2 className="section-title">
            II. Информация об адресе нахождения технических средств хранения
            исходного текста и объектного кода программного обеспечения, а также
            технических средств компиляции исходного текста в объектный код
            программного обеспечения
          </h2>

          <p className="section-text">
            Инфраструктура обеспечивающая работу облачной версии программного
            обеспечения, включая технические средства хранения исходного текста
            и объектного кода, а также технические средства компиляции,
            находятся на территории Российской Федерации по адресу: 111024, г.
            Москва, ул. Авиамоторная, 69 (Data Pro I). Провайдером указанной
            услуги является ООО «Хостинг-технологии» ИНН 7721833428 на основании
            заключенного с Заявителем договора от 11.09.2025 № 2257/427120/25, в
            соответствии с правовой и технической документацией, размещенной в
            сети Интернет по адресам:
          </p>

          <ul className="provider-links">
            <li>
              <a href="https://vdsina.ru" className="provider-link">
                https://vdsina.ru
              </a>
            </li>
            <li>
              <a href="https://vdsina.ru/documents" className="provider-link">
                https://vdsina.ru/documents
              </a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Technical;
